import { render, staticRenderFns } from "./PostLogin.vue?vue&type=template&id=cafc08f8&"
import script from "./PostLogin.vue?vue&type=script&lang=js&"
export * from "./PostLogin.vue?vue&type=script&lang=js&"
import style0 from "./PostLogin.vue?vue&type=style&index=0&id=cafc08f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports